import BaiduMapDialog from './Index.vue'

BaiduMapDialog.install = function(Vue) {
    Vue.component(BaiduMapDialog.name, BaiduMapDialog)
}

export default BaiduMapDialog
